(function (angular) {
    'use strict';

    angular.module('Common')

        /**
         *
         */
        .factory('linkedinSDKService',
        ['$http',
            function ($http) {
               
                var _isLoaded = false;
                var _linkedin_data_partner_id = "109104";
      
                var sdk = {
                    init: function () {
                        if (!_isLoaded) {
                            var s = document.getElementsByTagName("script")[0];
                            var b = document.createElement("script");
                            b.type = "text/javascript";
                            b.async = true;
                            b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js"; s.parentNode.insertBefore(b, s);
                            _isLoaded = true;
                        }
                    }
                };

                return sdk;

            }]);

})(window.angular);